<template>
  <div
    class="PageView"
    role="main"
  >
    <MenuView
      v-if="hasMenu"
      :application="application"
      :other-applications-number="otherApplicationsNumber"
      :own-applications-number="ownApplicationsNumber"
      @update-applications-list="$emit('update-applications-list', $event)"
    />
    <div :class="`column PageView-container ${hasMenu ? '' : 'noMenu'}`">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { useRouter } from "vue-router";
import services from "@/composable/services";
import MenuView from "@/views/common/MenuView.vue";
import "@/style/views/common/PageView.scss";
import { LocalApplicationResult } from "@/types/front/LocalApplicationResult";
import { PropType } from "vue";

export default {
  name: "PageView",

  components: { MenuView },
  props: {
    application: {
      type: Object as PropType<LocalApplicationResult>,
      default: null,
    },
    otherApplicationsNumber: {
      type: Number,
      default: 0,
    },
    ownApplicationsNumber: {
      type: Number,
      default: 0,
    },
    hasMenu: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update-applications-list"],
  setup() {
    const router = useRouter();
    const doCreated = function () {
      const authenticatedUser = services.loginService.getAuthenticatedUser();
      if (!authenticatedUser?.id) {
        router.push("/login").catch(() => {});
      }
    };
    return { doCreated };
  },
};
</script>
